import {Base64} from 'js-base64';
import MD5 from 'md5';

export function isEmptyObject(obj: any) {
    // eslint-disable-next-line guard-for-in, no-unreachable-loop
    for (const t in obj) {
        // console.log(t, obj);
        return !1;
    }
    return !0;
}

export function isObject(obj: any) {
    return obj !== null && typeof obj === 'object';
}

export function isString(obj: any) {
    return obj !== null && typeof obj === 'string';
}

export function isFunction(obj: any) {
    return obj !== null && typeof obj === 'function';
}

export function isBool(obj: any) {
    return obj !== null && typeof obj === 'boolean';
}

export function isArray(obj: any) {
    return Object.prototype.toString.call(obj) === '[object Array]';
}

export function isPromise(val: any) {
    return val && typeof val.then === 'function';
}

export function getLocalData(data: any) {
    const localData: any = {};
    if (typeof data === 'string') {
        return window.localStorage.getItem(data);
    }
    data.map((item: string) => {
        localData[item] = (window.localStorage.getItem(item));
    });
    return localData;

}
export function delLocalData(data: any) {
    const localData: any = {};
    if (typeof data === 'string') {
        return window.localStorage.removeItem(data);
    }
    data.map((item: string) => {
        localData[item] = (window.localStorage.removeItem(item));
    });
    return localData;

}
//数组去重，数组求交集，数组求差集
export function unique(arr: any[]) {
    return [...new Set(arr)];
}
export function intersection(arr1: any[], arr2: any[]) {
    return arr1.filter(item => arr2.includes(item));
}
export function difference(arr1: any[], arr2: any[]) {
    return arr1.filter(item => !arr2.includes(item));
}
//隐藏手机号中间四位
//+8618108023361 -> +86181****3361
//18108023361 -> 181****3361
export function hidePhoneNumber(phone: string) {
       const numbers = phone.replace(/\D/g, '');
       if (numbers.length < 11) {
           return phone;
       }
       const prefix = phone.startsWith('+') ? '+' + numbers.slice(0, numbers.length - 11) : '';
       const mainPart = numbers.slice(-11);
       const hiddenMainPart = mainPart.slice(0, 3) + '****' + mainPart.slice(7);
       return prefix + hiddenMainPart;
}
export function setLocalData(data: any, value: any) {
    if (typeof data === 'string' && (typeof value === 'string' || typeof value === 'number')) {
        window.localStorage.setItem(data, JSON.stringify(value));
        return;
    }
    if (isObject(data) && !isEmptyObject(data)) {
        for (const setKey in data) {
            if (data.hasOwnProperty(setKey)) {
                window.localStorage.setItem(setKey, data[setKey]);
            }
        }
        return;
    }
}

export function formatDate(date: any) {
    function pad2(n: number): string {
        return n < 10 ? `0${n}` : `${n}`;
    }
    let time = '';
    if (typeof date === 'object') {
        time = `${date.getFullYear()}-${
            pad2((date.getMonth() as number) + 1)}-${
            pad2(date.getDate())}`;
    }

    else if (typeof date === 'string') {
        time = date.split(' ')[0];
    }
    return time;
}

export function formatSize(s: number) {
    if (s === null) {
        return '-';
    }

    let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let i = 0;
    while (i < units.length && s >= 1024) {
        s /= 1024;
        i++;
    }
    return `${Math.round(s * 100) / 100}${units[i]}`;
}

export function formatTime(s: number) {
    if (s == null) {
        return '-';
    }

    let units = ['s', 'm', 'h'];
    let i = 0;
    while (i < units.length - 1 && s >= 60) {
        s /= 60;
        i++;
    }

    return `${Math.round(s * 10) / 10}${units[i]}`;
}




export function listenStoreMsg(callback: any) {
    window.addEventListener('storage', function (ev) {
        if (ev.key === 'postMessage') {
            // removeItem同样触发storage事件，此时ev.newValue为空
            if (!ev.newValue) {
                return;
            }
            let message = JSON.parse(ev.newValue);
            callback(message);
        }
    });
}
export function deepClone<T>(obj: T): T {
    if (obj === null || typeof obj !== 'object') return obj;
    if (obj instanceof Date) return new Date(obj.getTime()) as any;
    if (obj instanceof Array) {
      const clonedArr: any[] = [];
      obj.forEach((item) => clonedArr.push(deepClone(item)));
      return clonedArr as any;
    }
    if (obj instanceof Object) {
      const clonedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          clonedObj[key] = deepClone(obj[key]);
        }
      }
      return clonedObj;
    }
    return obj;
  }
export function buildRoomNameByCarId(carId: string) {
    return +(carId.split('').reduce((i, j) => {
        if (isNaN(+j)) {
            return `${i}${j.charCodeAt(0)}`;
        };
        return `${i}${j}`;
    }, ''));
}

export function isEmpty(m: any) {
    if (isArray(m)) {
        return !m.length;
    }
    else if (isObject(m)) {
        return isEmptyObject(m);
    }
    return !m;

}

export function urlEncode(param: any, key?: any, encode?: any) {
    if (param == null) {
        return '';
    }
    let paramStr = '';
    let t = typeof (param);
    if (t === 'string' || t === 'number' || t === 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
    }
    else {
        for (let i in param) {
            let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
            paramStr += urlEncode(param[i], k, encode);
        }
    }
    return paramStr;
}

export function urlDecode(): any {
    let get = window.location.href.split('?')[1];
    if (get) {
        let params = get.split(/&|=/);
        let obj = {};
        for (let i = 0; i < params.length; i++) {
            if (params[i].includes('.')) {
                if (!obj[params[i].split('.')[0]]) {
                    obj[params[i].split('.')[0]] = {};
                }
                obj[params[i].split('.')[0]][params[i].split('.')[1]] = decodeURIComponent(params[++i]);
            }
            else {
                obj[params[i]] = decodeURIComponent(params[++i]);
            }
        }
        return obj;
    }
    return {};

}
export function debounce(fn: Function, delay?: number) {
    let timer: NodeJS.Timeout;
    delay || (delay = 250);
    
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            // @ts-ignore: this is intentionally used in arrow function for debounce behavior
            fn.apply(this, args);
        }, delay);
    };
}

export function getQuery(val: string): string | undefined {
    const w = location.hash.indexOf('?');
    const query = location.hash.substring(w + 1);

    const vars = query.split('&');
    for (const varItem of vars) {
        const pair = varItem.split('=');
        if (pair[0] === val) {
            return pair[1];
        }
    }
    return undefined;
}

export function getClosestNumber(array: number[], target: number) {
    let left = 0;
    let right = array.length - 1;
    let mid: any = null;

    while (right - left > 1) {
        mid = Math.floor((left + right) / 2);
        if (array[mid] < target) {
            left = mid;
        }
        else {
            right = mid;
        }
    }
    return Math.abs(array[left] - target) > Math.abs(array[right] - target) ? array[right] : array[left];
};

export const toDouble = (n: number) => {
    return n < 10 ? '0' + n : '' + n;
};


export function clearIframeFun(id: string) {
    let element:any = document.getElementById(id);

    if(!element) {
        return;
    }

    try {
        element.src = "javascript:void(0)";
        element.contentWindow.document.write(''); // 清空iframe内容 element.contentWindow.document.clear()
        element.contentWindow.close(); // 避免iframe内存泄漏 
        element.remove(); // 删除iframe 
        document.body.removeChild(element); 
    } catch (error) {
    
    }
}

export function felog(params: any){
    (new Image()).src = `${window.location.protocol}//${window.location.host}/api/remote/felog_report?data=${JSON.stringify(params.data)}&user_id=${params.account}&car_id=${params.carId}&case_id=${params.caseId}&phantom_id=${params.phantomId}`;
}

export function polymerizeTicket(arr: any = []) :any {
    if (!arr) {
        return;
    }

    const map: any = {};
    let result: any = [];
    let ticketId: string = "";

    arr.forEach((item:any) => {
        if(item.event_type === "SERVICE_BLOCK") {
            if (map[item.event_code]) {
                map[item.event_code].ids = `${map[item.event_code].ids},${item.id}`
            } else {
                map[item.event_code] = item;
                map[item.event_code].ids = `${item.id}`
            }
        } else {
            result.push(item);
        }

        if (item.event_code === "LUOBO_HMI2DRC_SOS") {
            ticketId = item.ticket_id;
        }
    });

    return {polymerizeList: result.concat(Object.values(map)), sosTicketId: ticketId};
}
 
export function isGoogleChrome() {
    return /Chrome/.test(window.navigator.userAgent) && !/OPR/.test(window.navigator.userAgent) && !/Edg/.test(window.navigator.userAgent);
}

// utils/device.ts
export const getDeviceID = (): string => {
    let deviceId = localStorage.getItem('device_id');

    if (!deviceId) {
        // 生成唯一设备ID
        deviceId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem('device_id', deviceId);
    }

    return deviceId;
};

export const getClientIP = async (): Promise<string> => {
    try {
        const response = await fetch('https://ipinfo.io/json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.warn('获取IP失败:', error);
        return '0.0.0.0'; // 默认值
    }
};






export function generateDigitCode(input: string, codeLength: number = 4): string {
    let hash = 0;
    
    for (let i = 0; i < input.length; i++) {
        // 字符值 × 位置权重 × 质数
        const charCode = input.charCodeAt(i);
        hash += charCode * (i + 1) * 131;
    }
    
    // 二次哈希增强随机性
    hash = (hash ^ (hash >>> 16)) * 0x45d9f3b;
    hash = (hash ^ (hash >>> 16)) * 0x45d9f3b;
    hash = hash ^ (hash >>> 16);
    
    // 确保正数并映射到指定位数的数字范围
    hash = Math.abs(hash);
    const maxValue = Math.pow(10, codeLength);
    const code = hash % maxValue;
    
    return code.toString().padStart(codeLength, '0');
}

export function getChangedValues(oldValues: any, newValues: any): any {
  const changedValues: any = {};

  if (!isObject(newValues)) {
    return newValues;
  }
  const allKeys = new Set([...Object.keys(oldValues || {}), ...Object.keys(newValues)]);

  for (const key of allKeys) {
    const oldValue = oldValues ? oldValues[key] : undefined;
    const newValue = newValues[key];

    if (typeof newValue === 'function' || typeof oldValue === 'function') {
      continue;
    }

    if (isObject(newValue) && isObject(oldValue)) {
      const nestedChanges = getChangedValues(oldValue, newValue);
      if (!isEmptyObject(nestedChanges)) {
        changedValues[key] = nestedChanges;
      }
    } else if (isArray(newValue) && isArray(oldValue)) {
      const sortedNew = [...newValue].sort();
      const sortedOld = [...oldValue].sort();
      if (JSON.stringify(sortedNew) !== JSON.stringify(sortedOld)) {
        changedValues[key] = newValue;
      }
    } else if (newValue !== oldValue) {
      if (oldValue === undefined && isArray(newValue) && newValue.length === 0) {
        continue;
      }
      if (newValue === undefined && isArray(oldValue) && oldValue.length === 0) {
        continue;
      }
      changedValues[key] = newValue;
    }
  }

  return changedValues;
}

/**
 * 加密数据
 * @param {string} strSecKey - 密钥
 * @param {string} strData - 要加密的数据
 * @param {string} intTm - 时间戳，如果为空则使用当前时间
 * @returns {Object} 返回包含key和auth的对象
 */
export function encodeSand(strSecKey, strData, intTm) {
    // 如果没有提供时间戳，使用当前时间
    if (!intTm) {
        intTm = Date.now().toString();
    }
    
    // Base64编码原始数据
    let strBase64 = Base64.encode(strData);
    let intDataLen = strBase64.length;
    
    // 计算第一部分MD5
    let strMd5Part1 = MD5(strSecKey + strBase64 + intTm);
    
    // 如果数据长度大于MD5长度，重复MD5字符串
    while (intDataLen > strMd5Part1.length) {
        strMd5Part1 += strMd5Part1;
    }
    // 截取到与数据相同的长度
    strMd5Part1 = strMd5Part1.substring(0, intDataLen);
    
    // 计算第二部分MD5
    let strMd5Part2 = MD5(strSecKey + strMd5Part1 + intTm);
    
    // 将第二部分MD5转换为字符数组
    let arrMd5Part2 = strMd5Part2.split('');
    
    // 将Base64字符插入到MD5第二部分中
    for (let i = 0; i < intDataLen; i++) {
        let pos = strMd5Part1.charCodeAt(i) % 32;
        // 在指定位置插入Base64字符
        arrMd5Part2.splice(pos, 0, strBase64[i]);
    }
    
    // 重新组合第二部分
    strMd5Part2 = arrMd5Part2.join('');
    
    // 组合最终认证字符串
    let strAuth = strMd5Part1 + strMd5Part2;
    
    return {
        key: intTm,
        auth: strAuth.trim()
    };
}